import { render, staticRenderFns } from "./CustomButton.vue?vue&type=template&id=d2d6656c&scoped=true&"
import script from "./CustomButton.vue?vue&type=script&lang=js&"
export * from "./CustomButton.vue?vue&type=script&lang=js&"
import style0 from "./CustomButton.vue?vue&type=style&index=0&id=d2d6656c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d6656c",
  null
  
)

export default component.exports